export const SESSION_STORAGE_KEYS = {
  PENDING_URL: 'PENDING_URL',
  RECOVERY_URL: 'RECOVERY_URL',
};
